import React from 'react'
import _ from 'lodash'
import axios from 'axios'

import TicketClientCorrespondence from 'Components/Tickets/Correspondence/Client'
import TicketSupportDeskCorrespondence from 'Components/Tickets/Correspondence/SupportDesk'

export default class TicketCorrespondence extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      comments: [],
      loading: true
    }
  }

  componentDidMount () {
    this.getComments()
  }

  getComments () {
    const { ticket, user_token } = this.props

    axios.get(`/api/tickets/${ticket.id}/comments.json`, { params: { user_token } })
      .then((response) => {
        this.setState({
          loading: false,
          comments: _.reverse(_.sortBy(response.data, comment => (comment.id)))
        })
      })
      .catch((e) => {
        this.setState({
          loading: false
        })
      })
  }

  addCommentToLog = (comment) => {
    this.setState((prevState) => {
      const { comments } = prevState

      return { comments: [comment, ...comments] }
    })
  }

  render () {
    const {
      hidden,
      current_user,
      ticket,
      attachmentAdmin,
      user_token,
      ticket_types,
      ticket_statuses,
      problems,
      problemEndPoint,
      problemViewer,
      updateAlert,
      updateTicket,
      assignCurrentUser
    } = this.props
    const { comments, loading } = this.state

    return (
      <div style={hidden ? { display: 'none' } : {}}>
        {!current_user.calligo_employee &&
          (
            <TicketClientCorrespondence
              comments={comments}
              addCommentToLog={this.addCommentToLog}
              loading={loading}
              ticket={ticket}
              attachmentAdmin={attachmentAdmin}
              user_token={user_token}
              current_user={current_user}
            />
          )
        }
        {current_user.calligo_employee &&
          (
            <TicketSupportDeskCorrespondence
              {...this.props}
              addCommentToLog={this.addCommentToLog}
              currentUser={current_user}
              comments={comments}
              loading={loading}
              ticket={ticket}
              attachmentAdmin={attachmentAdmin}
              ticket_types={ticket_types}
              ticket_statuses={ticket_statuses}
              problems={problems}
              problemEndPoint={problemEndPoint}
              problemViewer={problemViewer}
              updateAlert={updateAlert}
              updateTicket={updateTicket}
              assignCurrentUser={assignCurrentUser}
            />
          )
        }
      </div>
    )
  }
}
